(() => {
  'use strict';
  const drawer = document.getElementById('FerimikiIntegratedCartDrawer');
  const items = document.getElementById('FerimikiCompactCartItems');
  if (!drawer || !items || drawer.dataset.controllerReady) return;
  drawer.dataset.controllerReady = 'true';
  const root = window.Shopify?.routes?.root || '/';
  const panel = drawer.querySelector('[role="dialog"]');
  const errorNode = drawer.querySelector('[data-ferimiki-cart-error]');
  let refreshPromise = null;
  let mutationPending = false;
  let refreshAgain = false;
  let trigger = null;
  let unsubscribe = null;
  function setText(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function error(message = '') { setText(errorNode, message); }
  function money(cents, currency) {
    try { return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: currency || 'SEK' }).format(Number(cents || 0) / 100); }
    catch { return `${(Number(cents || 0) / 100).toFixed(2)} SEK`; }
  }
  function safeUrl(value, image = false) {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '#';
      if (!image && url.origin !== location.origin) return '#';
      return url.href;
    } catch { return '#'; }
  }
  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }
  function render(cart) {
    const active = document.activeElement;
    const activeKey = active?.closest('[data-cart-key]')?.dataset.cartKey;
    const activeAction = active?.dataset.ferimikiCartQuantity;
    const activeInput = active?.hasAttribute('data-ferimiki-cart-quantity-input');
    document.querySelectorAll('.hdr-cart-count-numb').forEach(el => setText(el, String(cart.item_count || 0)));
    drawer.querySelectorAll('[data-ferimiki-cart-title]').forEach(el => setText(el, `VARUKORG | ${cart.item_count || 0} |`));
    drawer.querySelectorAll('[data-ferimiki-cart-total]').forEach(el => setText(el, money(cart.total_price, cart.currency)));
    const fragment = document.createDocumentFragment();
    for (const item of cart.items || []) {
      const article = node('article', 'ferimiki-compact-cart-item');
      article.dataset.cartKey = item.key;
      const link = node('a', 'ferimiki-compact-cart-item__image');
      link.href = safeUrl(item.url);
      if (item.image) {
        const image = node('img');
        image.src = safeUrl(item.image, true); image.alt = item.product_title || ''; image.loading = 'lazy';
        link.append(image);
      }
      const details = node('div', 'ferimiki-compact-cart-item__details');
      details.append(node('span', 'ferimiki-compact-cart-item__title', item.product_title || ''));
      const variant = (item.options_with_values || []).map(option => option.value).filter(value => value && String(value).toLowerCase() !== 'default title').join(' | ');
      if (variant) details.append(node('span', 'ferimiki-compact-cart-item__variant', variant));
      details.append(node('span', 'ferimiki-compact-cart-item__price', money(item.final_price, cart.currency)));
      const actions = node('div', 'ferimiki-compact-cart-item__actions'); actions.dataset.cartKey = item.key;
      const decrease = node('button', '', '-'); decrease.type = 'button'; decrease.dataset.ferimikiCartQuantity = 'decrease'; decrease.setAttribute('aria-label', 'Minska antal');
      const input = node('input'); input.type = 'number'; input.min = '0'; input.step = '1'; input.inputMode = 'numeric'; input.value = String(item.quantity); input.dataset.ferimikiCartQuantityInput = ''; input.setAttribute('aria-label', `Antal ${item.product_title || ''}`);
      const increase = node('button', '', '+'); increase.type = 'button'; increase.dataset.ferimikiCartQuantity = 'increase'; increase.setAttribute('aria-label', 'Öka antal');
      const remove = node('button', 'ferimiki-compact-cart-remove', 'TA BORT'); remove.type = 'button'; remove.dataset.ferimikiCartRemove = '';
      actions.append(decrease, input, increase, remove); details.append(actions); article.append(link, details); fragment.append(article);
    }
    if (!cart.items?.length) fragment.append(node('p', 'ferimiki-compact-cart-empty', 'Din varukorg är tom'));
    items.replaceChildren(fragment);
    if (activeKey && drawer.contains(active) === false && isOpen()) {
      const row = [...items.querySelectorAll('[data-cart-key]')].find(el => el.dataset.cartKey === activeKey);
      const target = activeInput ? row?.querySelector('input') : [...(row?.querySelectorAll('button') || [])].find(el => activeAction && el.dataset.ferimikiCartQuantity === activeAction);
      (target || panel)?.focus();
    }
  }
  async function request(path, options = {}) {
    const response = await fetch(root + path, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Varukorgen kunde inte uppdateras. Försök igen.');
    return data;
  }
  function refresh() {
    if (mutationPending) { refreshAgain = true; return Promise.resolve(null); }
    if (refreshPromise) { refreshAgain = true; return refreshPromise; }
    refreshPromise = request('cart.js').then(cart => { if (!mutationPending) render(cart); return cart; })
      .catch(() => { if (isOpen()) error('Varukorgen kunde inte hämtas. Öppna varukorgen igen för att försöka på nytt.'); return null; })
      .finally(() => { refreshPromise = null; if (refreshAgain && !mutationPending) { refreshAgain = false; refresh(); } });
    return refreshPromise;
  }
  function isOpen() { return drawer.classList.contains('is-open'); }
  function open(element) {
    if (!isOpen()) trigger = element || document.activeElement;
    window.FerimikiDrawerCoordinator?.closeOthers('cart');
    document.querySelector('cart-drawer')?.close?.();
    drawer.classList.remove('is-closing'); drawer.classList.add('is-open', 'open', 'active'); drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ferimiki-cart-drawer-open'); trigger?.setAttribute('aria-expanded', 'true');
    error(); refresh(); panel?.focus();
  }
  function close() {
    if (!isOpen()) return;
    drawer.classList.remove('is-open', 'open', 'active'); drawer.classList.add('is-closing'); drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ferimiki-cart-drawer-open');
    document.querySelectorAll('[data-ferimiki-cart-trigger],#cart-link').forEach(el => el.setAttribute('aria-expanded', 'false'));
    if (trigger?.isConnected) trigger.focus();
    setTimeout(() => { if (!isOpen()) drawer.classList.remove('is-closing'); }, 220);
  }
  async function change(key, quantity) {
    if (mutationPending) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) { error('Ange ett heltal som är noll eller större.'); return; }
    mutationPending = true; items.setAttribute('aria-busy', 'true');
    items.querySelectorAll('button,input').forEach(el => { el.disabled = true; });
    error();
    try {
      if (refreshPromise) await refreshPromise;
      const cart = await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      render(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'ferimiki-integrated-cart' } }));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ferimiki-integrated-cart', cartData: cart });
    } catch (failure) { error(failure.message || 'Varukorgen kunde inte uppdateras. Försök igen.'); refreshAgain = true; }
    finally {
      mutationPending = false; items.setAttribute('aria-busy', 'false');
      items.querySelectorAll('button,input').forEach(el => { el.disabled = false; });
      if (refreshAgain) { refreshAgain = false; refresh(); }
    }
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-ferimiki-cart-trigger],#cart-link');
    if (opener && !opener.classList.contains('cart-icon--bubble-cart-page')) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (isOpen()) close(); else open(opener); return;
    }
    if (event.target.closest('[data-ferimiki-cart-close]') && drawer.contains(event.target)) { event.preventDefault(); close(); return; }
    const action = event.target.closest('[data-ferimiki-cart-quantity],[data-ferimiki-cart-remove]');
    if (!action || !drawer.contains(action)) return;
    event.preventDefault();
    const group = action.closest('[data-cart-key]'); const input = group?.querySelector('input');
    if (!group || !input) return;
    const current = Number(input.value);
    const next = action.hasAttribute('data-ferimiki-cart-remove') ? 0 : current + (action.dataset.ferimikiCartQuantity === 'increase' ? 1 : -1);
    change(group.dataset.cartKey, Math.max(0, next));
  }, true);
  drawer.addEventListener('change', event => {
    const input = event.target.closest('[data-ferimiki-cart-quantity-input]');
    if (input) change(input.closest('[data-cart-key]').dataset.cartKey, Number(input.value));
  });
  document.addEventListener('keydown', event => {
    if (!isOpen() || document.body.classList.contains('cc-lock')) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      const choices = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el => el.getClientRects().length);
      const first = choices[0]; const last = choices[choices.length - 1];
      if (!choices.length) { event.preventDefault(); panel.focus(); }
      else if (!panel.contains(document.activeElement) || (event.shiftKey && document.activeElement === first)) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  ['cart:updated', 'cart:refresh'].forEach(name => document.addEventListener(name, event => {
    if (event.detail?.source !== 'ferimiki-integrated-cart') refresh();
  }));
  function attachThemeEvents() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => { if (event?.source !== 'ferimiki-integrated-cart') refresh(); });
    }
  }
  attachThemeEvents();
  const bubbleObserver = new MutationObserver(() => { if (!mutationPending && isOpen()) refresh(); });
  document.querySelectorAll('.hdr-cart-count-numb').forEach(el => bubbleObserver.observe(el, { childList: true, characterData: true, subtree: true }));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(drawer)) { unsubscribe?.(); bubbleObserver.disconnect(); }
  });
  window.FerimikiCartDrawer = { open, close, toggle: element => isOpen() ? close() : open(element), sync: refresh };
  drawer.getSectionsToRender = () => [];
  drawer.setActiveElement = element => { trigger = element; };
  drawer.renderContents = () => {
    refreshAgain = true;
    refresh().then(() => open(trigger));
  };
  refresh();
})();
